import { FEATURE_CLOUDFLARE_IMAGE_OPTIMIZATION } from '@/core/constants/features'
import useFeatures from '@/core/utils/features/useFeatures'

import { getCloudflareImageUrl } from './providers/cloudflare'
import { getCloudinaryImageUrl } from './providers/cloudinary'
import { GetCloudImageUrl } from './types'

type UseCloudImageReturn = {
  cloudImageUrl: GetCloudImageUrl
}

/**
 * useCloudImage hook returns the cloud image URL based on the feature flag
 *
 * @returns An object with function to get the cloud image URL
 *
 * @example
 * ```tsx
 * const { cloudImageUrl } = useCloudImage()
 * const src = cloudImageUrl('my-image-id', { width: 300, height: 200, format: 'webp' })
 * return <img src={src} alt="Description" />
 * ```
 */
export function useCloudImage(): UseCloudImageReturn {
  const hasCloudflareImageOptimizationEnabled = useFeatures(
    FEATURE_CLOUDFLARE_IMAGE_OPTIMIZATION,
  )

  const cloudImageUrl = hasCloudflareImageOptimizationEnabled
    ? getCloudflareImageUrl
    : getCloudinaryImageUrl

  return {
    cloudImageUrl,
  }
}
